import { HiOutlineCog } from "react-icons/hi";

interface MenuHeaderProps {
  title?: string;
  tagline?: string;
  logoUrl?: string;
  monogram: string;
  openNow: boolean;
  onOpenHours: () => void;
  onOpenSettings: () => void;
}

const MenuHeader = ({
  title,
  tagline,
  logoUrl,
  monogram,
  openNow,
  onOpenHours,
  onOpenSettings,
}: MenuHeaderProps) => (
  <header className="menu-header">
    <div className="menu-header__row">
      <div className="menu-mark">
        <div className="menu-mark__ring">
          {logoUrl ? <img src={logoUrl} alt={title || "Logo"} /> : <span>{monogram}</span>}
        </div>
      </div>
      <div className="menu-header__actions">
        <button className="menu-header__hours" onClick={onOpenHours}>
          <span className={"dot " + (openNow ? "dot--on" : "dot--off")}></span>
          <span className="menu-header__hours-text">
            {openNow ? "Open now" : "Closed"}
            <em>Hours ·</em>
          </span>
        </button>
        <button
          className="menu-header__icon-btn"
          onClick={onOpenSettings}
          aria-label="Settings"
        >
          <HiOutlineCog />
        </button>
      </div>
    </div>
    {title && <h1 className="menu-name">{title}</h1>}
    {tagline && <p className="menu-tagline">{tagline}</p>}
  </header>
);

export default MenuHeader;
